import React from "react";
import {
    SCHEDULES_REPORT_METHOD_LABELS,
    SchedulesReportMethod,
} from "@common/types/reports/schedules-report";
import { SchedulesReportEnumSelect } from "./SchedulesReportEnumSelect";
import { resolveSchedulesReportMethodOptions } from "./schedulesReportMethodOptions";

interface Props {
    value: SchedulesReportMethod;
    isMilestoneEnabled: boolean;
    onChange: (method: SchedulesReportMethod) => void;
}

export const RecognitionMethodSelect: React.FC<Props> = ({
    value,
    isMilestoneEnabled,
    onChange,
}) => (
    <SchedulesReportEnumSelect
        value={value}
        options={resolveSchedulesReportMethodOptions({ isMilestoneEnabled })}
        allValue={SchedulesReportMethod.all}
        labels={SCHEDULES_REPORT_METHOD_LABELS}
        prefix="Method"
        onChange={onChange}
    />
);
